import { Injectable } from "@angular/core";
import {
  PRIMITIVE,
  ClientMessageBrokerFactory,
  ClientMessageBroker,
  FnArg,
  UiArguments,
  FnTransferableArg,
} from "shared/provider-webworker";
import { CubiqWorker } from "../../worker/CubiqWorker";
import { TraderGroupLookupService } from "../../lookup/model/impl/TraderGroupLookupService";

import { Subject } from "rxjs";

import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { TradeQueryRequestPromiseService } from "./TradeQueryRequestPromiseService";
import { CHANNEL_TRADE_QUERY_REQUEST } from "../ITradeQueryRequestService";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class TradeQueryRequestReplicaService implements TradeQueryRequestPromiseService {
  protected broker: ClientMessageBroker;

  constructor(protected factory: ClientMessageBrokerFactory) {
    this.broker = this.factory.createMessageBroker(CHANNEL_TRADE_QUERY_REQUEST, true, true);
  }

  public request(tradeQuery: CubiqTS.TradeQueryRequest): Promise<CubiqTS.StandardReport> {
    let request = new UiArguments("request");

    request.args = [new FnArg(tradeQuery, CubiqTS.ENCODABLE(CubiqTS.TradeQueryRequestImpl))];

    return this.broker.runOnService(request, CubiqTS.ENCODABLE(CubiqTS.StandardReportImpl));
  }

  public requestAdaptedTradeData(tradeQuery: CubiqTS.TradeQueryRequest): Promise<Array<any>> {
    let request = new UiArguments("requestAdaptedTradeData");

    request.args = [new FnArg(tradeQuery, CubiqTS.ENCODABLE(CubiqTS.TradeQueryRequestImpl))];

    return this.broker.runOnService(request, PRIMITIVE);
  }
}
